import { SocialIcons } from '@/components/icons/SocialIcons';
import { providerLabelKey, toSocialIconType } from '@/features/campaigns/v2/utils/campaignProviderDisplay';
import type { CampaignV2ProviderType } from '@/services/endpoints/campaigns/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type CampaignProviderChipProps = {
  providerType: CampaignV2ProviderType | string;
  className?: string;
};

export const CampaignProviderChip: FC<CampaignProviderChipProps> = ({ providerType, className }) => {
  const { t } = useTranslation('campaign');
  const iconType = toSocialIconType(providerType);
  const label = iconType ? t(providerLabelKey(iconType)) : providerType;

  return (
    <span
      className={twMerge(
        'inline-flex items-center gap-1.5 rounded-full border border-secondary-border bg-white-100 py-0.5 pl-0.5 pr-2.5',
        className
      )}
    >
      {iconType ? <SocialIcons type={iconType} className='p-1.5' iconClassName='size-3.5' /> : null}
      <span className='text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-700'>{label}</span>
    </span>
  );
};
